const cud = !!(typeof window !== 'undefined' && window.document && window.document.createElement);
export default cud;